/**
 * Registers FCM device token with backend when user opens Chat
 * Enables push notifications for new chat messages
 */

import { useEffect, useRef } from 'react';
import api from '../config/api';
import {
  getFCMToken,
  requestNotificationPermission,
} from '../config/firebase';

export function useFCMToken(enabled: boolean) {
  const registeredRef = useRef<string | null>(null);

  useEffect(() => {
    if (!enabled) return;

    let cancelled = false;

    async function register() {
      const permission = await requestNotificationPermission();
      if (permission !== 'granted' || cancelled) return;

      const token = await getFCMToken();
      if (!token || cancelled) return;

      // Avoid re-registering same token
      if (registeredRef.current === token) return;
      registeredRef.current = token;

      try {
        await api.post('/api/chat/device-token', {
          token,
          platform: 'web',
        });
      } catch (err) {
        console.warn('[FCM] Failed to register token:', err);
        registeredRef.current = null;
      }
    }

    register();
    return () => {
      cancelled = true;
    };
  }, [enabled]);
}
